/**
 * MCG-specific theme overrides for WaitScreen component
 * Customizes the gray color palette to match MCG's design system
 */

export const WAIT_SCREEN_GRAY_THEME_CLASS = 'mcg-wait-screen-gray-theme'

export const WAIT_SCREEN_GRAY_THEME_OVERRIDES = `
  .wait-screen-slide-container > .overflow-x-hidden {
    overflow-y: hidden !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container .wait-screen-slide-container .course-page-scroll {
    background: transparent !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .bg-white.border.border-gray-200.overflow-hidden.relative.z-10 {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section {
    border-color: transparent !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section
    .bg-gray-100 {
    background-color: #e0e4ea !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section
    .bg-gray-200 {
    background-color: #dbe1e9 !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='5']
    .bg-gray-100
    .bg-gray-200 {
    background-color: #f0f3f7 !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='tabs1']
    .relative.grid.grid-cols-3.border-b.border-gray-100.mb-12
    .h-4.bg-gray-100.rounded-full.w-20 {
    background-color: #e0e4ea !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='tabs1']
    .space-y-4.px-4
    .bg-gray-100 {
    background-color: #e0e4ea !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='tabs1']
    .relative.grid.grid-cols-3.border-b.border-gray-100.mb-12
    .absolute.left-0 {
    background-color: #64748b !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='4']
    .aspect-square {
    background-color: #ffffff !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section[data-section-id='6']
    .border.border-gray-100.shadow-sm {
    background-color: #ffffff !important;
    border-color: #e5e7eb !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section:last-child
    .bg-white {
    background-color: #ffffff !important;
  }

  .mcg-wait-screen-gray-theme .wait-screen-image-container
    .wait-screen-slide-container
    .course-page-section:last-child
    .border-gray-200 {
    border-color: #d1d5db !important;
  }
`
